import { img } from './site'
import { Extra, Service } from '../types/booking'

export { euro } from '../utils/format'

export const services: Service[] = [
  {
    id: 'interior',
    name: 'Interieur Reiniging',
    summary:
      'Elk oppervlak binnenin afgestoft, geëxtraheerd en beschermd — instappen voelt weer als de eerste dag.',
    price: 95,
    durationMinutes: 180,
    image: img.interior,
    active: true,
    includes: [
      'Gehele interieur afstoffen en stofzuigen',
      'Shampoo-extractie in combinatie met stoom op stoelen en vloermatten',
      'Alle kunststofdelen behandelen met UV-protectie',
      'Optie: coating voor het leder of stoffen interieur',
    ],
  },
  {
    id: 'showroom',
    name: 'Showroom Pakket',
    summary:
      'Binnen en buiten in één bezoek opgefrist. Onze meest complete behandeling voor een auto die er moet staan.',
    price: 295,
    durationMinutes: 300,
    image: img.wash,
    active: true,
    includes: [
      'Interieur en exterieur gedetailleerd opfrissen',
      'Luxe handwas en velgen intensief reinigen',
      'Luchtventilatie doorstomen',
      'Gehele interieur afstoffen en stofzuigen',
      'Shampoo-extractie in combinatie met stoom op stoelen en vloermatten',
    ],
  },
  {
    id: 'paint-correction',
    name: 'Lakcorrectie',
    summary:
      'Doffe lak, swirls of waskrassen? Onze polijstbehandelingen halen de imperfecties eruit en herstellen de glans.',
    price: 549,
    durationMinutes: 420,
    image: img.correction,
    active: true,
    includes: [
      'Meest gekozen: 2-staps polijstbehandeling',
      'Verwijdering van medium lakdefecten tot medium krassen',
      'Lakcorrectie 80 — 95%, maximale glans',
      'Aanbrengen paste wax of sealant naar keuze',
    ],
  },
]

export const extras: Extra[] = [
  {
    id: 'ceramic',
    name: 'Keramische coating',
    price: 299,
    note: '1 — 2 jaar extra bescherming',
    durationMinutes: 120,
    active: true,
  },
  {
    id: 'leather',
    name: 'Interieurcoating',
    price: 149,
    note: 'Leder of stof, vlekbestendig',
    durationMinutes: 60,
    active: true,
  },
  {
    id: 'engine',
    name: 'Motorruimte reiniging',
    price: 65,
    note: 'Gedetailleerd reinigen en dressen',
    durationMinutes: 45,
    active: true,
  },
]
